export default {"src":"/_next/static/image/public/images/instagram.d37acdd3974dacaf3e481b89c513d92d.svg","height":512,"width":512};